import PropTypes from 'prop-types';
import React from 'react';

const ReactPropTypes = PropTypes;

class Checkbox extends React.Component {
	static propTypes = {
	  id: ReactPropTypes.string,
	  checked: ReactPropTypes.bool,
	  onChecked: ReactPropTypes.func,
	};

	static defaultProps = {
	  id: 'checkbox_id',
	  checked: false,
	  onChecked: null,
	};

	render() {
	  return (
  <div className="checkbox">
    <input type="checkbox" id={this.props.id} checked={this.props.checked} onChange={this.props.onChecked} />
    <label htmlFor={this.props.id} />
  </div>
	  );
	}
}

module.exports = Checkbox;
